import { render, staticRenderFns } from "./ProductsType.vue?vue&type=template&id=0691220a&scoped=true"
import script from "./ProductsType.vue?vue&type=script&lang=js"
export * from "./ProductsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0691220a",
  null
  
)

export default component.exports